/**
 * Widget-local hook: derives selection-dependent metadata used by the container.
 *
 * Encapsulates the logic for:
 * - Defaulting the selection display texts when nothing is selected.
 * - Determining whether future projections ("showFuture") are available.
 * - Exposing the current timespan choice + units.
 * - Calculating hasPossibilities flag used for UI enablement.
 */

import {
  getSelectionGraphic,
  getTimespansFromCommunicationStore,
  getUnits,
} from "utils/possibilities";

const useSelectionMeta = ({ CommunicationStore, selectionUnits = [] }) => {
  let {
    entity,
    displayText: selectedEntity,
    entityTypeDisplayText: entityDisplayText,
    // name,
  } = getSelectionGraphic(CommunicationStore) || {};

  if (!entity && !selectedEntity) {
    entityDisplayText = "Auswahl";
    selectedEntity = "";
  }

  // const showFuture = Boolean(
  //   (selectionUnits?.indexOf?.(name) !== -1 && entity) ||
  //     !entity ||
  //     name === "Bundesland",
  // );

  const units = getUnits(CommunicationStore);

  const { current: currentChoice = null, decimalPlaces } =
    getTimespansFromCommunicationStore(CommunicationStore);

  const possibilities = currentChoice ? currentChoice.possibilities : [];

  const hasPossibilities = Boolean(possibilities && possibilities.length > 0);

  // const graphicTooLittle = Boolean(
  //   currentChoice && possibilities?.length && !showFuture,
  // );

  return {
    entityDisplayText,
    selectedEntity,
    units,
    currentChoice,
    decimalPlaces,
    hasPossibilities,
    // graphicTooLittle,
  };
};

export default useSelectionMeta;
